/**
 * Deterministic FNV-1a string hashing used to fingerprint generated-CDF
 * inputs. Shared so that every generator produces identical, stable CDF
 * identity hashes.
 */
export function hashStringFNV1a(value: string, seed: number): string {
  let hash = seed >>> 0

  for (let index = 0; index < value.length; index += 1) {
    hash = Math.imul(hash ^ value.charCodeAt(index), 0x01000193)
  }

  return (hash >>> 0).toString(16).padStart(8, '0')
}

/**
 * Builds a stable signature hash from an ordered list of parts. Undefined
 * parts are treated as empty so the hash is positional and reproducible.
 */
export function getGeneratedCdfSignatureHash(
  signatureParts: readonly (string | number | undefined)[]
): string {
  const signature = signatureParts
    .map((part) => (part === undefined ? '' : String(part)))
    .join('\u001f')

  return [
    hashStringFNV1a(signature, 0x811c9dc5),
    hashStringFNV1a(signature, 0xa72c4f1d),
    hashStringFNV1a(signature, 0x2c1b3c6d),
  ].join('')
}
